import axios from 'axios';
import { MessageBox, Message } from 'element-ui'

// 创建axios实例
const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // subfix with:/
  timeout: 1000 * 60
});
// 设置post请求头
instance.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
instance.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
instance.defaults.withCredentials = true;
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.response.use(
  // config => {
  //   let url = config.url
  //   // get参数编码
  //   if (config.method === 'get' && config.params) {
  //     url += '?'
  //     let keys = Object.keys(config.params)
  //     for (let key of keys) {
  //       url += `${key}=${encodeURIComponent(config.params[key])}&`
  //     }
  //     url = url.substring(0, url.length - 1)
  //     config.params = {}
  //   }
  //   config.url = url
  //   return config
  // },
  // 请求成功
  res => res.status === 200 ? Promise.resolve(res) : Promise.reject(res),
  // 请求失败
  error => {
    const { response } = error;
    // if (response) {
    //   // 请求已发出，但是不在2xx的范围
    //   return Promise.reject(response);
    // } else {
    Message.error(`服务忙，请稍后再试`);
    // }
  });

export default instance;




// WEBPACK FOOTER //
// ./src/utils/http.js